import { useTranslation } from 'react-i18next';
import React, { memo } from 'react';
import { useParams } from 'react-router-dom';

import { DesktopHeader2 } from '@/components';

import DetailContainer from './DetailContainer';
import ListContainer from './ListContainer';

export const DesktopContainer = memo(() => {
  const { t } = useTranslation();

  const { id } = useParams<{
    id: string;
  }>();

  if (id) {
    return (
      <>
        <DesktopHeader2 title={t('DesktopContainer.1dno49x')} enableBack />
        <DetailContainer id={id} />
      </>
    );
  }
  return (
    <>
      <DesktopHeader2 title={t('DesktopContainer.zzc0lt')} />
      <ListContainer />
    </>
  );
});

export * from '../types';
export * from '../hooks';
